<!--
  name : 김혜진
  desc : 비대면 관리자 사용자 로그 조회 화면
  * 기존 login>index 소스 가져다가 씀
  date : 
-->

<template>
  <v-container>
    <v-row no-gutters justify="center">
      <v-col cols="12" class="untactADlogin_main_title" >관리자 로그인</v-col>
    </v-row>
    <v-row no-gutters align="center" justify="center" class="row_mb-40">
			<v-form autocomplete="on" ref="loginForm">
      <v-card id="popStyle02" class="popW472">
        <v-card-text>
          <v-row no-gutters class="w350">
            <v-col cols="12">
              <v-text-field class="inputH48_01"
                label="아이디"
                placeholder=" "
                v-model="adminInfo.id"
                outlined
                dense
								autoComplete="on"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field class="inputH48_01"
                label="비밀번호"
                placeholder=" "
                v-model="adminInfo.password"
                outlined
                dense
								autoComplete="on"
								:type="'password'"
                @keyup.enter="handleLogin"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="mb-2"><v-btn text class="btn19_C01 btn_only" @click.native.prevent="handleLogin">로그인</v-btn></v-col>
          </v-row>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
			</v-form>
    </v-row>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
  </v-container>
</template>

<script>
import { loginAdmin } from '@/api/login'

export default {
  name: 'untact-admin-login',
  data () {
    return {
      adminInfo: {
        id: '',
        password: ''
      },
    }
  },
  components: {
  },
  filters: {
  },
  methods : {
    handleLogin() {
      this.$refs.loading.start('로그인 중입니다.')
      loginAdmin(this.adminInfo).then(response => {
          this.$refs.loading.end()
          if(response.rdata.rcode === 20000) {
            this.$store.dispatch('AdminLogin', "success")
            this.$router.push('voucherLog')
          }else{
            this.$refs.confirm.open('alert', '어드민 로그인', '로그인에 실패했습니다.')
          }       
        }).catch(() => {
        })
    }
  }
}
</script>
<style>
 .untactADlogin_main_title{
    margin-top: 60px;
    margin-bottom: 40px;
    text-align: center;
    font-size: 1.8rem;
    color: #fff;
    font-weight: 500;
}

@media (max-width: 960px) {
    .untactADlogin_main_title {
      margin-top: 40px;
      margin-bottom: 30px;
    }
}
</style>